// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".block{margin-top:30px;padding-bottom:30px}.el-pager{font-size:12px!important;color:#666}.el-pager li{width:32px;height:27px;border:1px solid #999;margin-right:15px!important;font-weight:400}.el-pager li.active{color:#fff!important;background:#b50e05;cursor:pointer}.el-pager li.active+li{border-left:1px solid #999}", ""]);
// Exports
module.exports = exports;
